import { createSystem, defaultConfig, defineConfig, defineRecipe } from '@chakra-ui/react';

const buttonRecipe = defineRecipe({
  base: {
    borderRadius: '100px',
    fontSize: '12px',
  },
  variants: {
    size: {
      md: {
        h: '34px',
        px: '24px',
        minW: '34px',
        fontSize: '12px',
        borderRadius: '100px',
      },
      sm: {
        h: '24px',
        px: '12px',
        minW: '24px',
        fontSize: '10px',
        borderRadius: '100px',
      },
    },
    variant: {
      primary: {
        bg: '#000000',
        color: '#4DBEF8',
        h: '36px',
        px: '16px',
        minW: '36px',
        fontSize: '14px',
        borderRadius: '100px',
        _hover: {
          bg: '#1A1A1A',
        },
      },
      inline: {
        bg: 'transparent',
        fontWeight: 'regular',
        color: '#4DBEF8',
        padding: '0px !important',
        textDecoration: 'underline',
      },
    },
  },
  defaultVariants: {
    variant: 'primary',
    size: 'md',
  },
});

const customConfig = defineConfig({
  theme: {
    recipes: {
      button: buttonRecipe,
    },
  },
});

const system = createSystem(defaultConfig, customConfig);

export default system;
